import React from 'react';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import {SvgIcon} from '@mui/material';

function GradientIcon({firstColor, secondColor, children, gradientId, disabled}) {
    return (
        <>
            <svg width={0} height={0}>
                <defs>
                    <linearGradient id={gradientId} x1="0%" y1="0%" x2="0%" y2="100%">
                        <stop offset="0%" stopColor={`${disabled ? firstColor : "#7f7f7f"}`}/>
                        <stop offset="100%" stopColor={`${disabled ? secondColor : "#7f7f7f"}`}/>
                    </linearGradient>
                </defs>
            </svg>
            {children}
        </>
    );
}

export default GradientIcon;
